
import { createSlice } from "@reduxjs/toolkit";

export const initialBulkDocs=
    {
        bulk_upload_id:null,
        bulk_upload_name: '',
        documents: [
          {
            domain: {
              id: null,
              name: ''
            },
           process: {
              id:null,
              name: ''
            },
            sub_process: {
              id: null,
              name: ''
            },
            docs: [
            ]
          }
        ]
}

const initialValidationDocs={
bulk_upload_id: null,
bulk_upload_name: "",
documents_name_not_found: [],
documents_already_present: [],
documents_size_exceeded:[]
}

const initialState= {
    bulkUploadDocs: initialBulkDocs,
    originalBulkDocs: initialBulkDocs,
    uploadValidationDocs: initialValidationDocs
}


const bulkUploadSlice = createSlice({
    name: "bulkupload",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
         .addCase('LOGOUT', (state) => {
            localStorage.setItem('user', null);
            Object.assign(state, initialState);
         })
    },
    reducers:{
        setBulkUploadDocs: (state, action) => {
            state.bulkUploadDocs= action.payload?action.payload:initialBulkDocs ;
        },
        setOriginalBulkDocs: (state, action) => {
            state.originalBulkDocs = action.payload?action.payload:initialBulkDocs;
        },
        setUploadValidationDocs:(state, action) => {
            state.uploadValidationDocs = action.payload?action.payload:initialValidationDocs;
        }
  
    }
})

export const {  setBulkUploadDocs,setOriginalBulkDocs,  setUploadValidationDocs } = bulkUploadSlice.actions
export default bulkUploadSlice.reducer